import { render } from "./SSOEdit.vue?vue&type=template&id=280da61a"
import script from "./SSOEdit.vue?vue&type=script&lang=js"
export * from "./SSOEdit.vue?vue&type=script&lang=js"

import "./SSOEdit.vue?vue&type=style&index=0&id=280da61a&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__